import axiosApi from "shared/api/axiosApi";
import { AxiosResponse } from "axios";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";
import { downloadCorporateClientsExcelParams, GetMarathonClientsParams, GetMarathonClientsResponse, getCorporateClientName } from "../types/corporateClientTypes";

export const corporateClientAPI = {
  getCorporateClientsByMarathonId: async (data: GetMarathonClientsParams): Promise<AxiosResponse<GetMarathonClientsResponse>> => {
    return await axiosApi.get(
      `corporateClients/${data?.marathonId}`,
      {
        params: {
          searchTerm: data?.searchTerm,
          page: data?.page,
          pageSize: data?.pageSize,
        },
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      },
    );
  },
   getCorporateClientNamesByMarathonId: async (marathonId: number): Promise<AxiosResponse<getCorporateClientName[]>> => {
    return await axiosApi.get(
      `/corporateclients/${marathonId}/names`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
  },
  downloadCorporateClientsExcel: async (data: downloadCorporateClientsExcelParams) => {
    return await axiosApi.get(
      `/corporateclients/${data?.marathonId}/excel`,
      { responseType: "blob" }
    );
  }
}